export default "__VITE_ASSET__c1MQq2hE__"